import { useTranslation } from 'react-i18next';

export const Strike = ({ onClose }) => {
    const { t } = useTranslation();

    const storage = localStorage.getItem('streak');

    return (
        <div
            onClick={onClose}
            className="w-full h-full absolute z-[60] bg-bgBlack/30 flex justify-center items-center"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="w-[244px] h-[76px] md:w-[347px] md:h-[101px] lg:w-[401px] lg:h-[282px] rounded-[19px] border-[3px] md:border-[4px] border-[#7743BA] bg-[#FFF] flex items-center justify-center"
            >
                <div className="w-[184px] md:w-[316px] mx-auto font-fredokaOne">
                    <p className="text-[16px] md:text-[20px] lg:text-[24px] text-[#F68C2F] text-center lg:mt-[27px] lg:mb-[17px] mt-[11px] mb-[12px] md:mt-[20px] md:mb-[16px]">
                        {t("day_streak").replace("X", storage)}
                    </p>
                </div>
            </div>
        </div>
    );
};
